<template>
  <n-button ghost custom-icon="fas fa-sync-alt" text="refresh" @on-click="$emit('on-click')" />
</template>

<script>
export default {
  name: 'NbRefresh',
};
</script>
